import { apiFetch } from "@/lib/api/client";
import { removeKnowledgeDoc } from "@/lib/knowledge-docs";
import type { ContractTypeGuidelineDocumentRecord, CustomRoleInstructionDocumentRecord } from "@/types";

export async function listContractTypeGuidelineDocuments(
  contractTypeId: string
): Promise<ContractTypeGuidelineDocumentRecord[]> {
  return apiFetch(`/api/contract-types/${contractTypeId}/guideline-documents`);
}

export async function insertContractTypeGuidelineDocument(payload: {
  contract_type_id: string;
  file_path: string;
  file_name: string;
  extracted_text: string;
  omit_document_ids?: string[];
}): Promise<void> {
  await apiFetch(`/api/contract-types/${payload.contract_type_id}/guideline-documents`, {
    method: "POST",
    body: JSON.stringify({
      file_path: payload.file_path,
      file_name: payload.file_name,
      extracted_text: payload.extracted_text,
      omit_document_ids: payload.omit_document_ids ?? [],
    }),
  });
}

export async function deleteContractTypeGuidelineDocument(id: string, contractTypeId: string): Promise<void> {
  const docs = await listContractTypeGuidelineDocuments(contractTypeId);
  const doc = docs.find((d) => d.id === id);
  if (doc?.file_path) await removeKnowledgeDoc(doc.file_path);
  await apiFetch(`/api/contract-type-guideline-documents/${id}`, {
    method: "DELETE",
  });
}

export async function listCustomRoleInstructionDocuments(
  customRoleId: string
): Promise<CustomRoleInstructionDocumentRecord[]> {
  return apiFetch(`/api/custom-roles/${customRoleId}/instruction-documents`);
}

export async function insertCustomRoleInstructionDocument(payload: {
  custom_role_id: string;
  file_path: string;
  file_name: string;
  extracted_text: string;
  omit_document_ids?: string[];
}): Promise<void> {
  await apiFetch(`/api/custom-roles/${payload.custom_role_id}/instruction-documents`, {
    method: "POST",
    body: JSON.stringify({
      file_path: payload.file_path,
      file_name: payload.file_name,
      extracted_text: payload.extracted_text,
      omit_document_ids: payload.omit_document_ids ?? [],
    }),
  });
}

export async function deleteCustomRoleInstructionDocument(id: string, customRoleId: string): Promise<void> {
  const docs = await listCustomRoleInstructionDocuments(customRoleId);
  const doc = docs.find((d) => d.id === id);
  if (doc?.file_path) await removeKnowledgeDoc(doc.file_path);
  await apiFetch(`/api/custom-role-instruction-documents/${id}`, {
    method: "DELETE",
  });
}
